import { IconProps } from 'components/icons/Icons.types';
import React from 'react';
import styles from './Icon.module.scss';

const EyeIcon: React.FC<IconProps> = ({
  className = '',
  size = 24,
  color = '#fffff0',
  fillColor = 'transparent',
  fillOpacity = 1,
  circleStrokeColor = '#fffff0',
}) => {
  const baseCls = `${styles.IconContainer} ${className}`;
  return (
    <div className={baseCls}>
      <svg width={size} height={size} viewBox="0 0 24 24" fill="transparent" xmlns="http://www.w3.org/2000/svg">
        <circle
          fill={fillColor}
          fillOpacity={fillOpacity}
          cx="12"
          cy="12"
          r="10.5"
          stroke={circleStrokeColor}
          strokeWidth={'1.5px'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="m12 5.5c4 0 7.4 2.7 8.3 6.5-.9 3.7-4.3 6.5-8.3 6.5-4-.1-7.4-2.8-8.3-6.5C4.6 8.3 8 5.5 12 5.5ZM12 17c-3.2 0-5.9-2.1-6.8-5C6.1 9.1 8.8 7 12 7s5.9 2.1 6.8 5c-.9 2.9-3.6 5-6.8 5zm2.9-5c0 1.6-1.3 2.9-2.9 2.9S9.1 13.6 9.1 12 10.4 9.1 12 9.1s2.9 1.3 2.9 2.9zm-1.4 0c0 .8-.6 1.4-1.4 1.4s-1.4-.6-1.4-1.4.6-1.4 1.4-1.4 1.4.6 1.4 1.4z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default EyeIcon;
